<!--ANNOUNCEMENT-->
<ng-container *ngIf="announcement">
  <section class="margin-top-offset">
    <!--WRAPPER-->
    <div class="wrapper">
      <!--SHARED CMS STATIC PAGE-->
      <app-static-page
        [title]="announcement.title"
        [bodyContent]="announcement.content | safe : 'html'">
      </app-static-page>
      <!--END SHARED CMS STATIC PAGE-->
    </div>
    <!--END WRAPPER-->
  </section>
</ng-container>
<!--END ANNOUNCEMENT-->
